<!--
 * @Author: chj
 * @Date: 2024-10-10 14:49:19
 * @LastEditors: chj
 * @LastEditTime: 2024-10-22 10:25:19
 * @Description: 请填写简介
-->
<template>
  <div :class="bem()">
    <div :class="bem('header')">
      <h3 :class="bem('header-title')">会员周</h3>
      <router-link to="/member/week">
        <a-button type="link">更多>></a-button>
      </router-link>
    </div>
    <section :class="bem('wrapper')">
      <div :class="bem('left', { direction })">
        <!-- <h3 :class="bem('left-title')">{{ sectionItem.main_title }}</h3> -->
        <p :class="bem('left-desc')">{{ sectionItem.subheading }}</p>
      </div>
      <router-link
        to="/member/week"
        :class="bem('right')"
        v-if="sectionItem.thumb"
      >
        <div
          :class="bem('right-bg')"
          :style="`background-image: url(${sectionItem.thumb})`"
        ></div>
      </router-link>
    </section>
  </div>
</template>

<script>
import { Button as AButton } from "ant-design-vue";
import { getDynamic } from "@/api/cms/dynamic";
export default {
  name: "week-list",
  components: {
    AButton,
  },
  props: {
    direction: {
      type: String,
      default: "right",
    },
  },
  data() {
    return {
      queryParams: {
        type: 22,
        pageNum: 1,
        pageSize: 1,
      },
      sectionItem: {},
    };
  },
  methods: {
    async initData() {
      try {
        const res = await getDynamic(this.queryParams);
        if (res.code == 0) {
          const [item] = res.data.list;
          this.sectionItem = item;
        }
      } catch (err) {
        console.log("err", err);
      }
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
.week-list {
  width: 100%;
  overflow: hidden;
  margin-bottom: 80px;
  @include devices(laptop) {
    padding: 0 40px;
  }
  @include devices(phone) {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
  }
  &__header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    &-title {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 40px;
      line-height: 32px;
      color: #ff6900;
      font-size: 24px;
      text-align: center;
      &::after {
        position: absolute;
        content: "";
        bottom: 0px;
        width: 84px;
        height: 4px;
        background-color: rgba(212, 7, 24, 1);
      }
    }
  }
  &__wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 20px auto 0;
    @include devices(phone) {
      display: flex;
      flex-direction: column;
    }
  }
  &__left {
    flex: 1 1 auto;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    &--direction {
      &-left {
        padding-left: 0;
        padding-right: 148px;
        @include devices(laptop) {
          padding-right: 98px;
        }
        @include devices(phone) {
          padding-right: 0;
        }
      }
      &-right {
        order: 2;
        padding-left: 48px;
        padding-right: 0;
        @include devices(laptop) {
          padding-left: 48px;
        }
        @include devices(phone) {
          order: 0;
          padding-left: 0;
        }
      }
    }
    &-title {
      margin-bottom: 22px;
      font-size: 32px;
      line-height: 45px;
      font-weight: 500;
      color: #1a1a1a;
      @include devices(phone) {
        font-size: 22px;
        line-height: 33px;
      }
    }
    &-desc {
      // margin-bottom: 27px;
      margin: 0;
      font-size: 16px;
      line-height: 26px;
      color: rgba(11, 38, 64, 0.68);
    }
    &-more {
      display: flex;
      justify-content: flex-end;
    }
  }
  &__right {
    flex: 0 0 30.8%;
    @include devices(phone) {
      margin-top: 20px;
      width: 100%;
    }
    &-bg {
      min-height: 266px;
      border-radius: 4px;
      overflow: hidden;
      background-size: cover;
      background-position: 50%;
    }
  }
}
</style>
